import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';

import withRouter from '../../partials/Common/withRouter';
import Navdata from '../LayoutMenuData';

const VerticalLayout = (props: any) => {
  const menuItemsData = Navdata();
  const [menuItems, setMenuItems] = useState(menuItemsData);
  const path = props.router.location.pathname;

  /*
   layout settings
   */

  // useEffect(() => {
  //   setMenuItems(menuItemsData);
  // }, [menuItemsData]);

  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      leftsidbarSizeType: layout.leftsidbarSizeType,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
      layoutType: layout.layoutType,
    }),
  );
  // Inside your component
  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(
    selectLayoutProperties,
  );

  //vertical and semibox resize events
  const resizeSidebarMenu = useCallback(() => {
    const windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
    const hamburgerIcon = document.querySelector('.hamburger-icon');
    if (windowSize >= 1025) {
      if (document.documentElement.getAttribute('data-layout') === 'vertical') {
        document.documentElement.setAttribute(
          'data-sidebar-size',
          leftsidbarSizeType,
        );
      }
      if (document.documentElement.getAttribute('data-layout') === 'semibox') {
        document.documentElement.setAttribute(
          'data-sidebar-size',
          leftsidbarSizeType,
        );
      }
      if (
        (sidebarVisibilitytype === 'show' ||
          layoutType === 'vertical' ||
          layoutType === 'twocolumn') &&
        document.querySelector('.hamburger-icon')
      ) {
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove('open');
        }
      } else {
        // var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add('open');
        }
      }
    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove('twocolumn-panel');
      if (document.documentElement.getAttribute('data-layout') === 'vertical') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (document.documentElement.getAttribute('data-layout') === 'semibox') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (humberIcon) {
        humberIcon.classList.add('open');
      }
    } else if (windowSize <= 767) {
      document.body.classList.remove('vertical-sidebar-enable');
      if (
        document.documentElement.getAttribute('data-layout') !== 'horizontal'
      ) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
      if (humberIcon) {
        humberIcon.classList.add('open');
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener('resize', resizeSidebarMenu, true);
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path;
      const ul = document.getElementById('navbar-nav') as HTMLElement;
      const items: any = ul.getElementsByTagName('a');
      const itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);
      const matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    if (props.layoutType === 'vertical') {
      initMenu();
    }
  }, [path, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add('active');
    const parentCollapseDiv = item.closest('.collapse.menu-dropdown');

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add('show');
      parentCollapseDiv.parentElement.children[0].classList.add('active');
      parentCollapseDiv.parentElement.children[0].setAttribute(
        'aria-expanded',
        'true',
      );
      if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
        parentCollapseDiv.parentElement
          .closest('.collapse')
          .classList.add('show');
        if (
          parentCollapseDiv.parentElement.closest('.collapse')
            .previousElementSibling
        )
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.classList.add('active');
        if (
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.closest('.collapse')
        ) {
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.closest('.collapse')
            .classList.add('show');
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.closest('.collapse')
            .previousElementSibling.classList.add('active');
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    const actiItems = items.filter((x: any) => x.classList.contains('active'));

    actiItems.forEach((item: any) => {
      if (item.classList.contains('menu-link')) {
        if (!item.classList.contains('active')) {
          item.setAttribute('aria-expanded', false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
      }
      if (item.classList.contains('nav-link')) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
        item.setAttribute('aria-expanded', false);
      }
      item.classList.remove('active');
    });
  };

  const [openItemIds, setOpenItemIds] = useState(new Set<string>());

  const handleItemClick = (itemId, isChildren?: boolean) => {
    if (isChildren) {
      setOpenItemIds((prevOpenItemIds) => {
        const newOpenItemIds = new Set(prevOpenItemIds);
        if (newOpenItemIds.has(itemId)) {
          newOpenItemIds.delete(itemId);
        } else {
          newOpenItemIds.add(itemId);
        }
        return newOpenItemIds;
      });
    } else {
      setOpenItemIds(new Set());
    }
  };

  const renderMenuItem = (item, depth: number = 0, isChildren?: boolean) => {
    const isOpen = openItemIds.has(item.id);
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const marginLeft = depth * 16; // margin adjustment for sublevels

    return (
      <li className="nav-item" key={item.id}>
        {hasSubItems ? (
          <div
            className={`nav-link menu-link cursor-pointer selec ${
              isOpen && hasSubItems ? 'active' : ''
            }`}
            data-bs-toggle={`collapse`}
            style={{ marginLeft: `${marginLeft}px` }}
            onClick={() => handleItemClick(item.id, true)}
            aria-expanded={isOpen ? 'true' : 'false'}
          >
            <i className={item.icon}></i>
            <span data-key="t-apps">{props.t(item.label)}</span>
            <i
              className={`fas fa-chevron-right ml-auto ${isOpen ? 'rotate' : ''}`}
            ></i>{' '}
          </div>
        ) : (
          <Link
            className="nav-link menu-link"
            to={item.link || '/#'}
            style={{ marginLeft: `${marginLeft}px` }}
            onClick={() =>
              isChildren ? null : handleItemClick(item.id, false)
            } // closes all items when clicking a link
          >
            <i className={item.icon}></i>
            <span>{props.t(item.label)}</span>
          </Link>
        )}
        {hasSubItems && isOpen && (
          <ul className="nav nav-sm flex-column test">
            {item.subItems.map((subItem) =>
              renderMenuItem(subItem, depth + 1, true),
            )}
          </ul>
        )}
      </li>
    );
  };

  return (
    <React.Fragment>
      <nav id="navbar-nav" className="navbar">
        <ul
          id="vertical-menu"
          className="navbar-nav bg-gradient-primary sidebar"
        >
          {/* {menuItemsData.map((item: any) => renderMenuItem(item))} */}
        </ul>
      </nav>
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
